type Push = {
  type: "history/PUSH"
  payload: {
    url: string
  }
}

export type Action = Push

export const PUSH = "history/PUSH"

export const pushUrl = (url: string): Push => ({
  type: PUSH,
  payload: { url },
})
